import styled, { css } from 'styled-components';
import { Link as ReactLink } from 'react-router-dom';
import { respondTo } from 'components/styles/_respondTo';

export const Wrapper = styled.li`
  padding: 10px 20px;
  position: relative;
  min-height: 47px;
  display: flex;

  ${({ isFooter }) =>
    isFooter &&
    css`
      border-bottom: 1px solid #565656;
      &:last-child {
        border-bottom: none;
      }
    `}

  ${respondTo.desktop`
     ${({ active }) =>
       active &&
       css`
         background-color: #ff782842;
         &:before {
           content: '';
           position: absolute;
           height: 100%;
           width: 2px;
           background-color: white;
           left: 0;
           top: 0;
         }
       `}
  `}
  ${respondTo.mobile`
    &:after {
    content: '';
    width: 100%;
    position: absolute;
    height: 1px;
    background-color: #FF7828;
    opacity: 0.3;
    bottom: 0;
    left: 0;
  }
  ${({ topBorder }) =>
    topBorder &&
    css`
      margin-top: 13%;
      &:before {
        content: '';
        width: 100%;
        position: absolute;
        height: 1px;
        background-color: #ff7828;
        opacity: 0.3;
        top: 0;
        left: 0;
      }
    `}
  `}
`;

export const Link = styled(ReactLink)`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;

export const ListLabel = styled.span`
  ${({ theme }) =>
    theme === 'menu_item' &&
    css`
      margin-left: 32px;
      font-family: 'IBM Plex Sans', sans-serif;
      //font-family: 'IBMPlexMedium', sans-serif;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.71;
      letter-spacing: normal;
      color: rgba(255, 255, 255, 0.78);
    `}
  ${({ theme }) =>
    theme === 'primary_item' &&
    css`
      //font-family: 'IBMPlexMedium';
      font-family: 'IBM Plex Sans', sans-serif;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.71;
      letter-spacing: normal;
      color: #636262;
    `}
`;

export const SuffixImage = styled.img`
  position: absolute;
  right: 20px;
`;

export const Image = styled.img`
  width: 20px;
  max-height: 20px;
`;
